export const ONE_DAY = '1day';
export const TWO_DAYS = '2days';
export const ONE_WEEK = '1week';
export const ONE_MONTH = '1month';